export default "__VITE_ASSET__289185de__"